import { HttpClient, HttpBackend, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AbstractAppConfig } from '../../../app.config';
import { DocumentDownload } from '../../domain/document/document-download.model';
import { DocumentUpload } from '../../domain/document/document-upload.model';

@Injectable()
export class DocumentStoreService {

  private anonymousHttpClient: HttpClient;

  constructor(private appConfig: AbstractAppConfig,
              private httpClient: HttpClient,
              handler: HttpBackend,
            ) {
              this.anonymousHttpClient = new HttpClient(handler);
            }

  downloadUrl(docId: String): Observable<DocumentDownload> {
    const url = this.baseUrl();
    return this.httpClient.get<DocumentDownload>(`${this.baseUrl()}/${docId}`);
  }

  newUploadUrl(metadata): Observable<DocumentUpload> {
    const url = this.baseUrl();
    const body = this.appConfig.secureDocumentOnUpload() !== 'false' ? {metadata} : {};
    return this.httpClient.post<DocumentUpload>(this.baseUrl(), body);
  }

  upload(file: File, upload: DocumentUpload, metadata = {filename: undefined}): Observable<string> {
    const {filename} = metadata;
    const headers = this.uploadHeaders(this.appConfig.secureDocumentOnUpload() !== 'false' ? metadata : {filename});

    return this.anonymousHttpClient.put(upload.upload_url, file, {headers})
                                   .pipe(
                                     map(response => upload.id),
                                   );
  }

  private baseUrl(): string {
    if (this.appConfig.getAttachmentStoreUrl()) {
      return this.appConfig.getAttachmentStoreUrl() + '/attachments';
    }
    return this.appConfig.getDocumentStoreUrl() + '/documents';
  }

  private uploadHeaders(metadata): HttpHeaders {
    let headers = {};

    switch (this.appConfig.getAttachmentStoreProvider()) {
      case 'azure-blob':
        headers = Object.assign({}, headers, this.azureBlobHeaders(), this.metadataHeaders('x-ms-meta-', metadata));
        break;
      case 'google-storage':
        headers = Object.assign({}, headers, this.metadataHeaders('x-goog-meta-', metadata));
        break;
    }

    return new HttpHeaders(headers);
  }

  private azureBlobHeaders(): object {
    return {
      'x-ms-blob-type': 'BlockBlob',
    };
  }

  private metadataHeaders(prefix, metadata) {
    return Object.keys(metadata)
                 .map((key) => [prefix + key, metadata[key]])
                 .reduce((acc, [key, value]) => {
                   acc[key] = value;
                   return acc;
                 }, {});
  }
}
